import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.AirwallexBatchPaymentRequestCard.PaymentProcessingDetails', {
    paymentProcessingDetails: 'Payment processing details',
    totalPayments: 'Total payments:',
    paymentsSent: 'Payments sent:',
    paymentsFailed: 'Payments failed:',
    paymentsInProcessing: 'Payments in processing:',
});
